import '../../../vendor/ohmediaorg/backend-bundle/assets/js/confirm.js';

export class Collection {
  constructor(options) {
    if (!options.addBtn) {
      throw new Error('The "addBtn" option is required.');
    }
    if (!options.container) {
      throw new Error('The "container" option is required.');
    }
    if (typeof options.maxItems !== 'number') {
      throw new Error(
        'The "maxItems" option is required and must be a number.'
      );
    }
    if (!options.form) {
      throw new Error('The "form" option is required.');
    }

    this.addBtn = options.addBtn;
    this.container = options.container;
    this.maxItems = options.maxItems;

    this.items = {};
    this.itemsIndex = 0;

    this.form = options.form;

    this.addBtn.addEventListener('click', (e) => {
      this._addCollectionItem();
    });
  }

  _createCollectionItem(el = null) {
    throw new Error(
      'The "_createCollectionItem" method must be implemented in the child class.'
    );

    //example
    // return new CollectionItem({
    //   index: this.itemsIndex,
    //   el: el,
    // });
  }

  _processNewCollectionItem(item) {
    item.getDeleteBtn().addEventListener('click', async (e) => {
      const confirmed = await customConfirm(
        `Are you sure you want to delete this item?`
      );

      if (confirmed) {
        this._deleteCollectionItem(item);
      }
    });

    this.items[this.itemsIndex] = item;
    this.itemsIndex++;
  }

  addCollectionItem(elementId, index = null) {
    if(index) {
      this.itemsIndex = parseInt(index);
    }

    const item = this._createCollectionItem(elementId);
    this._processNewCollectionItem(item);
  }

  _addCollectionItem() {
    const item = this._createCollectionItem();
    this._processNewCollectionItem(item);
    this.container.append(item.render());

    this._checkLimits();
  }

  _deleteCollectionItem(item) {
    const index = item.getIndex();

    item.delete();
    delete this.items[index];

    this._checkLimits();
  }

  _collectionCount() {
    return Object.keys(this.items).length;
  }

  _checkLimits() {
    this._checkMaxItems();
  }

  _checkMaxItems() {
    this.addBtn.disabled = this._collectionCount() >= this.maxItems;
  }
}

export class CollectionItem {
  constructor(options) {
    if (options.index == null) {
      throw new Error('The "index" option is required.');
    }
    if (!options.template) {
      throw new Error('The "template" option is required.');
    }
    if (!options.prototypeName) {
      throw new Error('The "prototypeName" option is required.');
    }
    if (!options.fieldName) {
      throw new Error('The "fieldName" option is required.');
    }
    if (!options.deleteClass) {
      throw new Error('The "deleteClass" option is required.');
    }

    this.index = options.index;
    this.template = options.template;
    this.prototypeName = options.prototypeName;
    this.fieldName = options.fieldName;

    if (options.el) {
      this.el = options.el;
    } else {
      this.el = this.template.content.firstElementChild.cloneNode(true);
      this.el.innerHTML = this.el.innerHTML.replaceAll(
        this.prototypeName,
        this.index
      );
      this.el.id = this.el.id.replace(this.prototypeName, this.index);
    }

    this.prototypeName = options.prototypeName;
    this.fieldName = options.fieldName;
    this.deleteBtn = this.el.querySelector(`.${options.deleteClass}`);

    // identifier to find the item in the collection
    this.el.dataset.index = this.index;
  }

  getIndex() {
    return this.index;
  }

  getDeleteBtn() {
    return this.deleteBtn;
  }

  delete() {
    this.el.remove();
  }

  render() {
    return this.el;
  }
}
